import { render } from "./NavApp.vue?vue&type=template&id=64e9b763"
import script from "./NavApp.vue?vue&type=script&lang=js"
export * from "./NavApp.vue?vue&type=script&lang=js"

import "./NavApp.vue?vue&type=style&index=0&id=64e9b763&lang=scss"
script.render = render

export default script